import deps from './paths';
export default deps;